import PropTypes from "prop-types"
import parse from "html-react-parser"
import classnames from "classnames"
import questionMark from "images/icons/question-mark.svg?raw"
import questionMarkCircle from "images/icons/question-mark-circle.svg?raw"

// Two assets because the DSL uses the outlined glyph inside the desktop chip
// and the filled one bare on phone.
const LearnMoreButton = ({ darkHeader, title, url }) => {
  return (
    <a
      className={classnames("icon-button", "icon-button-shaded", "learn-more-icon", {
        "icon-button-on-color": darkHeader,
      })}
      title={title}
      aria-label={title}
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      href={url}
      rel="noreferrer"
    >
      <span className="hide-on-xs">{parse(questionMark)}</span>
      <span className="hide-above-xs">{parse(questionMarkCircle)}</span>
    </a>
  )
}

LearnMoreButton.propTypes = {
  darkHeader: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
}

LearnMoreButton.defaultProps = {
  darkHeader: false,
  title: "Learn more",
}

export default LearnMoreButton
